import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDmKKfNl3Vmy-vWS49PsBVZKQSIdTUZ2jc",
  authDomain: "paradigma-8c4d0.firebaseapp.com",
  projectId: "paradigma-8c4d0",
  storageBucket: "paradigma-8c4d0.firebasestorage.app",
  messagingSenderId: "657529733769",
  appId: "1:657529733769:web:ce939e31cbc42d8fd57c58",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
const db = getFirestore(app);

// Initialize Authentication
const auth = getAuth(app);

export { db, auth };
